var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#ea8536;}.cls-3{fill:#f2a156;}.cls-4{fill:#fff;}.cls-5{fill:#976332;}.cls-6{fill:#c65a10;}.cls-7{fill:#e5ad88;}.cls-8{fill:#d3b24b;}.cls-9{fill:#fed65c;}.cls-10{fill:#cf6614;}.cls-11{fill:#fbedc1;}.cls-12{fill:#cad0d8;}.cls-13{fill:#293b58;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "majster"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_543",
    "data-name": "Warstwa 543"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.02,
    y: 20.21,
    width: 1.74,
    height: 0.93,
    rx: 0.23,
    transform: "translate(-5.94 21.94) rotate(-34.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.22,
    y: 21.79,
    width: 1.74,
    height: 0.93,
    rx: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.82,15h1a.34.34,0,0,1,.34.34v6.49a0,0,0,0,1,0,0H27.49a0,0,0,0,1,0,0V15.3a.33.33,0,0,1,.33-.33Z",
    transform: "translate(56.6 36.76) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.71,14.67h.83a.3.3,0,0,1,.3.3v5.72a0,0,0,0,1,0,0H30.42a0,0,0,0,1,0,0V15a.29.29,0,0,1,.29-.29Z",
    transform: "translate(66.82 14.93) rotate(145.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 33.45,
    cy: 11.36,
    r: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.45,7.68h.37a.33.33,0,0,1,.33.33V17.3a0,0,0,0,1,0,0h-1a0,0,0,0,1,0,0V8a.32.32,0,0,1,.32-.32Z",
    transform: "translate(34.25 -18.25) rotate(76.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.49,
    y: 11.03,
    width: 1.16,
    height: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29.07,11.14h0c-1.43,0-1.6-.71-1.6-1.57V8.45a1.57,1.57,0,0,1,1.57-1.57h0a1.58,1.58,0,0,1,1.57,1.57V9.57C30.64,10.43,30.37,11.14,29.07,11.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.49,
    y: 6.51,
    width: 3.14,
    height: 3.97,
    rx: 1.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27.91,6h2.31a.41.41,0,0,1,.41.41V8a0,0,0,0,1,0,0H27.49a0,0,0,0,1,0,0V6.4A.42.42,0,0,1,27.91,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M26.74,7h1a0,0,0,0,1,0,0V8.35a0,0,0,0,1,0,0H25.57a0,0,0,0,1,0,0V8.16A1.17,1.17,0,0,1,26.74,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.22,6.33H27.91a.42.42,0,0,0-.42.43V7.3h-.9a1,1,0,0,0-1,1v0h5.06V6.75A.42.42,0,0,0,30.22,6.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 26.58,
    y: 7.66,
    width: 4.05,
    height: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M30.63,15.83H27.49V11.55a.41.41,0,0,1,.41-.41,1.94,1.94,0,0,0,1.16.5,2.32,2.32,0,0,0,1.17-.5.4.4,0,0,1,.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.64,16.1H27.5V11.91a.4.4,0,0,1,.4-.41,2,2,0,0,0,1.17.5,2.32,2.32,0,0,0,1.17-.5.4.4,0,0,1,.4.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 27.5,
    y: 15.31,
    width: 3.13,
    height: 0.79
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "28 19.07 10.96 19.07 10.96 8.03 22.34 8.02 28 16.08 28 19.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "9.5 22.53 9.5 8.53 20.27 8.53 27.5 18.87 27.5 22.53 9.5 22.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M20,9l7,10v3H10V9H20m.52-1H9V23H28V18.71l-.18-.26-7-10L20.52,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.51,22.53l0-5.17a1.47,1.47,0,0,1,.26-.88l3.65-5.39a1.27,1.27,0,0,1,1-.56H9.5v12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M5.43,11H9V22H1l0-4.67a1,1,0,0,1,.17-.6L4.8,11.37A.77.77,0,0,1,5.43,11m0-1A1.75,1.75,0,0,0,4,10.81L.32,16.2A2,2,0,0,0,0,17.37L0,22v1H10V10H5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M19.23,11H12V9h8l7,10v1H25Zm3.47-2H21l1.41,2H24.1Zm2,3H23l1.41,2h1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M21.9,24.84A1.87,1.87,0,1,1,23.77,23,1.87,1.87,0,0,1,21.9,24.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M21.9,21.85A1.12,1.12,0,1,1,20.78,23a1.12,1.12,0,0,1,1.12-1.12m0-1.5A2.62,2.62,0,1,0,24.52,23a2.62,2.62,0,0,0-2.62-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M16.12,24.84A1.87,1.87,0,1,1,18,23,1.87,1.87,0,0,1,16.12,24.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M16.12,21.85a1.12,1.12,0,1,1,0,2.24,1.12,1.12,0,1,1,0-2.24m0-1.5A2.62,2.62,0,1,0,18.74,23a2.62,2.62,0,0,0-2.62-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M4.12,24.84A1.87,1.87,0,1,1,6,23,1.87,1.87,0,0,1,4.12,24.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M4.12,21.85a1.12,1.12,0,0,1,0,2.24,1.12,1.12,0,1,1,0-2.24m0-1.5A2.62,2.62,0,1,0,6.74,23a2.62,2.62,0,0,0-2.62-2.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "7 16.03 0.42 16.03 3.14 12.03 7 12.03 7 16.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1.64 16.03 0.43 16.03 3.14 12.03 4.34 12.03 1.64 16.03"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToday);
export default __webpack_public_path__ + "static/media/today.c5ff2568e5b8c1828838efb8b5ea5d34.svg";
export { ForwardRef as ReactComponent };